<template>
  <van-tab :title="title">
    <van-list
      v-model="loading"
      finished-text="没有更多了"
      :finished="finished"
      :immediate-check="true"
      @load="onLoad"
    >
      <record-panel
        class="bgwhite"
        v-for="(item, index) in list"
        :key="index"
        :record="item"
        :has-footer="false"
        :has-toolbar="hasToolbar"
        :has-toolbar2="hasToolbar2"
        @refresh="onRefreshTab"
      />
    </van-list>
  </van-tab>
</template>

<script>
import { Icon, Tab, List, Dialog } from 'vant'
import RecordPanel from '@/views/record/components/RecordPanel'
import { userRecordList } from '@/api/record'

export default {
  name: 'RecordTab',
  components: {
    [Icon.name]: Icon,
    [Tab.name]: Tab,
    [List.name]: List,
    [Dialog.name]: Dialog,
    RecordPanel
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    status: {
      type: Number,
      default: undefined
    },
    review_status: {
      type: Number,
      default: undefined
    },
    reset: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    reset (value) {
      if (value) {
        this.onRefresh()
      }
    }
  },
  data () {
    return {
      keyword: '',
      hasToolbar: false,
      hasToolbar2: false,
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        clazz: undefined,
        status: undefined,
        review_status: undefined,
        page: 0,
        size: 8
      }
    }
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
    this.hasToolbar = this.review_status === 1
    this.hasToolbar2 = this.review_status === 3
    this.listQuery.clazz = this.clazzId
    this.listQuery.status = this.status
    this.listQuery.review_status = this.review_status
  },
  methods: {
    async getList () {
      this.loading = true
      let response = await userRecordList(this.listQuery)
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList()
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    },
    onRefresh () {
      this.listQuery.page = 1
      this.list = []
      this.getList()
    },
    onRefreshTab (record) {
      this.$emit('refresh')
    }
  }
}
</script>

<style scoped lang="scss">
</style>
